import * as address from 'smg/address';
import { UpdateCountryAndState } from 'smg/countries';
import * as html from 'smg/html';
import * as models from 'smg/models';
import * as smgphone from 'smg/phone';
import * as template from 'smg/template';

export const Format = address.Format;

export async function Draw(address: address.Address | models.ShippingOption | models.PaymentOption, phone?: string, email?: string, el: HTMLElement = template.Clone('#address-template')): Promise<HTMLElement> {
    const lines = el.querySelector('.address-lines');
    if (lines) {
        lines.innerHTML = html.Nl2br(await Format(address));
    }

    const phoneEl = el.querySelector<HTMLAnchorElement>('.address-phone');
    if (phone) {
        if (phoneEl) {
            phoneEl.textContent = smgphone.Human(phone);
            if (phoneEl instanceof HTMLAnchorElement) {
                phoneEl.href = smgphone.Format(phone);
            }
        }
    } else if (!phone) {
        phoneEl?.closest('.address-phone-parent')?.remove();
        phoneEl?.remove();
    }

    const emailEl = el.querySelector<HTMLAnchorElement>('.address-email');
    if (email) {
        if (emailEl) {
            emailEl.textContent = email;
            if (emailEl instanceof HTMLAnchorElement) {
                emailEl.href = `mailto:${email}`;
            }
        }
    } else if (!email) {
        emailEl?.closest('.address-email-parent')?.remove();
        emailEl?.remove();
    }

    return el as HTMLElement;
}

export async function FormatAddressOneLine(a: models.ShippingOption | models.PaymentOption): Promise<string> {
    await UpdateCountryAndState(a);

    let out = '';
    let city: string;
    switch (a.country?.countryCode2) {
    case 'CN':
    case 'IN':
    case 'US':
    case 'CA':
    case 'AU':
        city = [[a.city, a.state?.stateCode].filter(Boolean).join(', '), a.zip].filter(Boolean).join(' ');
        break;
    default:
        city = [a.zip, a.city].filter(Boolean).join(' ');
        break;
    }
    if (city) {
        out += `${city}, `;
    }
    if (a.country?.countryCode2) {
        out += a.country.countryCode2;
    }

    return out;
}